import React, { useState } from 'react'
import './modal-signed.scss'
import { StaticImage } from 'gatsby-plugin-image'
import shared_facebook from '../../../assets/images/modal-share/shared_facebook.png'
import shared_whatsapp from '../../../assets/images/modal-share/shared_whatsapp.png'
import shared_telegram from '../../../assets/images/modal-share/shared_telegram.png'
import {
  compartirFacebook,
  shareOnTelegram,
  shareOnWhatsApp,
} from '@/utils/shareFnc'
import Loader from 'react-loader-spinner'
import useMediaQuery from '@/utils/useMediaQuery'
import useTotalSigns from '@/hooks/useTotalSigns'
import { siteUrl } from '@/shared/utils/siteUrl'
import { LOCALE_AT } from '@/constants/activity-constants'
const $Eres = LOCALE_AT.PARAGUAY ? 'Sos' : 'Eres'
const $Comparte = LOCALE_AT.PARAGUAY ? 'Compartí' : 'Comparte'
const $tu = LOCALE_AT.PARAGUAY ? 'vos' : 'tú'

const sharePage = siteUrl + '/magazin/loving/'
const dataShared = [
  {
    title: 'compartir en facebook',
    image: shared_facebook,
    share: compartirFacebook,
  },
  {
    title: 'compartir en whatsapp',
    image: shared_whatsapp,
    share: shareOnWhatsApp,
  },
  {
    title: 'compartir en telegram',
    image: shared_telegram,
    share: shareOnTelegram,
  },
]
const ButtonShared = ({
  title,
  image,
  callToAction,
}: {
  title: string
  image: string
  callToAction: () => void
}) => {
  const [load, setLoad] = useState(false)
  return (
    <>
      {load ? (
        <Loader type="TailSpin" color="#ff0087" height={47} width={47} />
      ) : (
        <img
          onClick={title => {
            setLoad(true)
            callToAction()
            setTimeout(() => {
              setLoad(false)
            }, 500)
          }}
          className="btn-share"
          src={image}
          alt={title}
          title={title}
        />
      )}
    </>
  )
}

function ShareComp() {
  return (
    <div className={'f-share '}>
      {dataShared.map(data => {
        return (
          <ButtonShared
            key={data.title}
            title={data.title}
            image={data.image}
            callToAction={() => {
              data.share(sharePage)
            }}
          />
        )
      })}
    </div>
  )
}
function ImageSign() {
  if (LOCALE_AT.PARAGUAY) {
    return (
      <StaticImage
        className="f-modal-signed__media-image"
        src="../../../assets/images/img-signed-py.webp"
        alt="Certificado que yo firme contra el bullyng"
        width={386}
        height={386}
      />
    )
  }
  return (
    <StaticImage
      className="f-modal-signed__media-image"
      src="../../../assets/images/img-signed.webp"
      alt="Certificado que yo firme contra el bullyng"
      width={386}
      height={386}
    />
  )
}
export default function ModalSigned() {
  const [totalPeople] = useTotalSigns()
  const isMobile = useMediaQuery()
  return (
    <div className="f-modal-signed">
      <div className="f-modal-signed__wrapper ">
        {isMobile && <ShareComp />}
        <ImageSign />
        <aside>
          <h1 className="title">
            <span className="icon-corazon"></span>
            <b>¡Gracias!</b> {$Eres} la persona <b>{totalPeople}</b> en alzar{' '}
            <b>la voz contra el bullying.</b>
          </h1>
          <p className="subtitle">
            {$Comparte} esta inciativa para que llegue a más personas como {$tu}
            .
          </p>
          {!isMobile && <ShareComp />}
        </aside>
      </div>
    </div>
  )
}
